import { api, prefix } from "@/api";
import type { AxiosRequestConfig } from "axios";
import type { applicationType } from "@/types/application";
import type { roleUserType } from "@/types/role";

const namespace = "platform";

export const getApplicationList = (config: AxiosRequestConfig = {}) => {
  return api<Array<applicationType>>({
    url: `${prefix}/${namespace}/profile/application?extend=configuration`,
    method: "GET",
    ...config,
  });
};

export const getRoleList = (config: AxiosRequestConfig = {}) => {
  return api<Array<roleUserType>>({
    url: `${prefix}/profile/admin/role`,
    method: "GET",
    ...config,
  });
};
